import { PayoutEntryHedge } from '../../../state/Radom'

export const toCostNumber = (value: number | string | undefined): number => {
  const n = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(n) ? n : 0
}

export interface HedgedPayoutCostParts {
  guaranteedAmount: number
  lockedRate: number
  /** What one unit delivered costs in the funding asset, conversion fee included, network fee aside. */
  effectiveRate: number
  radomFee: number
  networkFee: number
  stablecoinCost: number
}

export const computeHedgedPayoutCosts = (
  hedge: PayoutEntryHedge,
  recipientAmount?: number | string
): HedgedPayoutCostParts => {
  const guaranteedAmount = toCostNumber(recipientAmount ?? hedge.guaranteedAmount)
  const lockedRate = toCostNumber(hedge.lockedRate)
  const radomFee = toCostNumber(hedge.conversionFee)
  const stableForTrade = toCostNumber(hedge.stableForTrade)
  const stablecoinCost = toCostNumber(hedge.stablecoinCost)
  const conversionAtRate = guaranteedAmount * lockedRate
  const networkFee = Math.max(0, stableForTrade - conversionAtRate)
  const effectiveRate = guaranteedAmount > 0 && stablecoinCost > 0
    ? Math.max(0, stablecoinCost - networkFee) / guaranteedAmount
    : lockedRate

  return {
    guaranteedAmount,
    lockedRate,
    effectiveRate,
    radomFee,
    networkFee,
    stablecoinCost
  }
}
